import React from 'react'
import Combaintop from '../Components/Combaintop/Top'
import CartDash from '../Components/User-Dashboard/CartDash'
import Combainbottom from '../Components/Combainbottom/Combainbottom'
function Cartdashboardpage() {
    return (
        <>
        <Combaintop/>
        <CartDash/>
        <Combainbottom/>
        </>
        
    )
}

export default Cartdashboardpage;
